module.exports = __webpack_public_path__ + "static/media/effect_triple.bd00a31d.png";